<template>
  <div class="padres-container">
    <div class="overlay-rosado" />
    <br><br>

    <!-- Corte de Honor -->
    <div class="bloque-texto">
      <div ref="corteTituloRef" class="texto-container texto-novia">
        <span class="novia">Corte de Honor</span>
      </div>

      <img ref="separador1Ref" src="@/assets/separador.png" class="separador-final" alt="Separador" />
      <span class="novia1">Quinceañera_</span><br><br>
      <div ref="quinceaneraRef" class="padrino-linea">Johanna Duran</div><br><br>

      <span class="novia1">Chambelan Principal</span><br><br>
      <div ref="chambelanRef" class="padrino-linea">Chris Duran</div><br><br>

      <span class="novia1">Damas:</span><br>
      <div class="padrinos-lista">
        <div v-for="(dama, i) in damas" :key="'dama' + i" ref="damaRefs" class="padrino-linea">{{ i + 1 }}. {{ dama }}</div>
      </div>
<br><br>
      <span class="novia1">Chambelanes:</span>
      <div class="padrinos-lista">
        <div v-for="(ch, i) in chambelanes" :key="'chambelan' + i" ref="chambelanRefs" class="padrino-linea">{{ i + 1 }}. {{ ch }}</div>
      </div>
    </div>

    <!-- Texto Padrinos -->
    <div class="bloque-texto">
      <div ref="padrinoTituloRef" class="texto-container texto-novia">
        <span class="novia">Mis Padrinos</span><br>
      </div>
    <div class="padrinos-lista">
  <div
    v-for="(padrino, i) in padrinos"
    :key="'padrino' + i"
    ref="padrinoRefs"
    class="padrino-linea"
    v-text="padrino"
  ></div>
</div>

    </div>

    <img ref="separador2Ref" src="@/assets/separador.png" class="separador-final" alt="Separador" />
  </div>
</template>
<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const corteTituloRef = ref(null)
    const quinceaneraRef = ref(null)
    const chambelanRef = ref(null)
    const padrinoTituloRef = ref(null)
    const separador1Ref = ref(null)
    const separador2Ref = ref(null)

    const damaRefs = ref([])
    const chambelanRefs = ref([])
    const padrinoRefs = ref([])

    const damas = [
      'Zajira Sosa', 'Kelsey Ponce', 'Delilah Gomez', 'Elayne Urbina', 'Isabella Garcia',
      'Alisson Rodriguez', 'Melany Madrigal', 'Ashley Jimenez', 'Cloe Vielot', 'Stephanie Charles'
    ]

    const chambelanes = [
      'Leo Berrios', 'Johan Andino', 'Matthew Morales', 'Jayden Velez', 'Mikey Lopez',
      'Anthony Ortiz', 'Axel Brito', 'Dominick Martinez', 'Lee Jones', 'David Urbina'
    ]

    const padrinos = [
      'Madrinas: \n\n Ana Maria Zamarripa', 'Lorena Brito', 'Luciana Selvera', 'Karina Navarro',
      'Rosalba Epigmenio', 'Francheska Martínez', 'Cindy Rivera', 'Regina Orellana',
      'Dinorka Bogris', 'Darbi Ortiz', 'Padrinos: \n\n Jose Brito', 'Juan Francisco Brito'
    ]

    const animateOnScroll = (el, delay = 0) => {
      if (!el) return
      el.style.opacity = 0
      el.style.transform = 'translateY(30px)' // más ligera

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: 0.6, // más rápida
            ease: 'power2.out',
            delay
          })
          observer.unobserve(el)
        }
      }, { threshold: 0.2 })

      observer.observe(el)
    }

    onMounted(async () => {
      await nextTick()

      const allElements = [
        corteTituloRef.value,
        separador1Ref.value,
        quinceaneraRef.value,
        chambelanRef.value,
        ...damaRefs.value,
        ...chambelanRefs.value,
        padrinoTituloRef.value,
        ...padrinoRefs.value,
        separador2Ref.value
      ]

      allElements.forEach((el, index) => {
        animateOnScroll(el, index * 0.05) // menor delay
      })
    })

    return {
      corteTituloRef,
      quinceaneraRef,
      chambelanRef,
      padrinoTituloRef,
      separador1Ref,
      separador2Ref,
      damaRefs,
      chambelanRefs,
      padrinoRefs,
      damas,
      chambelanes,
      padrinos
    }
  }
}
</script>


<style scoped>
.padres-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 0;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}

.overlay-rosado {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bloque-texto {
  margin-bottom: 40px;
  text-align: center;
}

.texto-container {
  z-index: 2;
  padding: 10px;
  max-width: 600px;
  font-family: 'Dancing Script', sans-serif;
  font-size: 18px;
  color: #5c4b51;
  margin: 0 auto;
}

.novia {
  font-family: 'british', cursive;
  font-size: 22px;
  color: #7e6d21;
}
.novia1 {
  font-family: 'british', cursive;
  font-size: 18px;
  color: #7e6d21;
}

.padrinos-lista {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.padrino-linea {
    white-space: pre-line; /* Muestra \n como saltos de línea */

  font-family: "padres", sans-serif;
  font-size: 20px !important;
  color: #9c916b;
  opacity: 0;
  transform: translateY(50px);
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.separador-final {
  width: 80vw;
  height: auto;
  margin: 20px auto;
  display: block;
  opacity: 0;
  transform: translateY(50px);
}

@media (max-width: 600px) {
  .padrino-linea {
    font-size: 16px;
  }
}
</style>
